var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-config-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "活动列表", name: "activityList" } },
            [
              _c("activityList", {
                attrs: { refresh: _vm.refresh },
                on: {
                  addAct: _vm.addAct,
                  handleEdit: _vm.handleEdit,
                  handleRecord: _vm.handleRecord,
                  handleReward: _vm.handleReward,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "发帖记录", name: "publishList" } },
            [
              _c("recordList", {
                key: "p-" + _vm.publishKey,
                attrs: { actId: _vm.actId, mode: "publish" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "领奖记录", name: "rewardList" } },
            [
              _c("recordList", {
                key: "r-" + _vm.rewardKey,
                attrs: { actId: _vm.actId, mode: "reward" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab === "activityAdd"
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.actId ? "编辑活动" : "添加活动",
                    name: "activityAdd",
                  },
                },
                [
                  _c("activityAdd", {
                    attrs: { actId: String(_vm.actId) },
                    on: { saved: _vm.saved },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }